import React from "react"
import { Helmet } from "react-helmet"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ title, description, twitterImageUrl, imageUrl, path }) {
  const GetSeoDataQuery = graphql`
    {
      contentfulGlobal {
        metaContent {
          metaImage {
            file {
              url
            }
          }
          metaDescription {
            metaDescription
          }
          metaImageTwitter {
            file {
              url
            }
          }
        }
      }

      site {
        siteMetadata {
          title
          description
          twitter
          url
        }
      }
    }
  `

  const { contentfulGlobal, site } = useStaticQuery(GetSeoDataQuery)

  const {
    metaTitle,
    metaImage,
    metaDescription,
    metaImageTwitter,
  } = contentfulGlobal.metaContent

  const twitterHandle = site.siteMetadata.twitter
  const siteUrl = site.siteMetadata.url
  const defaultTitle = site.siteMetadata.title
  const defaultDescription = site.siteMetadata.description

  const defaultImageUrl = metaImage ? "https:" + metaImage.file.url : ""
  const defaultTwitterImageUrl = metaImageTwitter
    ? "https:" + metaImageTwitter.file.url
    : defaultImageUrl

  return (
    <Helmet
      title={title || metaTitle || defaultTitle}
      meta={[
        { name: "twitter:card", content: "summary" },
        { name: "twitter:site", content: twitterHandle },
        { name: "twitter:title", content: title || metaTitle },
        {
          name: "twitter:description",
          content:
            description ||
            metaDescription.metaDescription ||
            defaultDescription,
        },
        {
          name: "twitter:image",
          content: twitterImageUrl || imageUrl || defaultTwitterImageUrl,
        },
        {
          name: "description",
          content:
            description ||
            metaDescription.metaDescription ||
            defaultDescription,
        },
        {
          property: "og:description",
          content:
            description ||
            metaDescription.metaDescription ||
            defaultDescription,
        },
        {
          property: "og:image",
          content: imageUrl || defaultImageUrl,
        },
        { property: "og:title", content: title || metaTitle || defaultTitle },
        { property: "og:url", content: path ? `${siteUrl}/${path}` : siteUrl },
      ]}
    />
  )
}

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  twitterImageUrl: PropTypes.string,
  imageUrl: PropTypes.string,
  path: PropTypes.string,
}

export default SEO
